import React from 'react'
import { StyleSheet, View } from 'react-native'

import { useRouter } from 'expo-router'

import { DS } from '@/design-system'

import { NavCard } from '@/screens/diamonds/components/NavCard'

interface RedeemCardProps {
  compact?: boolean
}

function RedeemCard({ compact = false }: RedeemCardProps) {
  const router = useRouter()

  return (
    <NavCard
      title="Redeem"
      handler={() => router.push('/diamonds/redeem')}
      showHeader={compact}
      isClickable={compact}
      scrollEnabled={!compact}
    >
      {!compact && (
        <View style={styles.content}>
          <DS.Text variant="Heading 5/Medium" color="Global/Black" textAlign="center">
            Coming Soon
          </DS.Text>
          <DS.Text variant="Body Small/Regular" color="Brand/Dark Grey" textAlign="center">
            Soon you'll be able to redeem your diamonds for custom cards, table felts, avatars and more. Keep earning!
          </DS.Text>
        </View>
      )}
    </NavCard>
  )
}

const styles = StyleSheet.create({
  content: {
    gap: DS.spacing[8]
  }
})

export { RedeemCard }
